import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getSingleBillDetails = (id: string, itemType: string) => {
  return axiosPrivate.get(`/bills/api/v1/transactions/${id}/status/?item_type=${itemType}`);
};